import React from 'react';
import { Link } from 'react-router-dom';
import './KeyHighlightsSection.css';

const HIGHLIGHTS = [
  {
    icon: '🏢',
    title: 'Corporate & Commercial Housekeeping',
    description: 'Daily cleaning and facility upkeep for offices and commercial spaces.'
  },
  {
    icon: '👥',
    title: 'Trained Manpower & Janitorial Staff',
    description: 'Verified, trained staff for cleaning and janitorial needs.'
  },
  {
    icon: '✨',
    title: 'Deep Cleaning & Sanitization',
    description: 'Thorough cleaning and sanitization for a safe, hygienic environment.'
  },
  {
    icon: '⚙️',
    title: 'Customized Facility Solutions',
    description: 'Tailored plans for your industry, schedule, and budget.'
  },
  {
    icon: '🚗',
    title: 'Valet Parking Service',
    description: 'Professional valet for malls, hotels, weddings, and corporate events in Ahmedabad.',
    to: '/service/valet-parking-ahmedabad'
  }
];

function KeyHighlightsSection() {
  return (
    <section className="key-highlights-section animate-on-scroll">
      <div className="container">
        <div className="key-highlights-grid">
          {HIGHLIGHTS.map((item, index) => {
            const inner = (
              <>
                <div className="key-highlight-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </>
            );
            if (item.to) {
              return (
                <Link key={index} to={item.to} className="key-highlight-card key-highlight-card--link">
                  {inner}
                </Link>
              );
            }
            return (
              <div key={index} className="key-highlight-card">
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default KeyHighlightsSection;
